import React from 'react';
import PropTypes from 'prop-types';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import fi from 'date-fns/locale/fi';
import './DatePicker.css';

import ReactDatePicker from "react-datepicker";
import { Typography } from "stories/components";

export const DatePicker = ({ children, label, error, errorText,placeholderText, required, ...rest }) => {
  registerLocale('fi', fi)
  return (
    <>
      { label ? (
        <Typography bold={false} className="sk-field-label">{label}{required ? "*" : ""}</Typography>
      ) : null }
      
      <ReactDatePicker
        locale="fi"
        
        placeholderText={placeholderText}
        {...rest}
      >
      {children}
      </ReactDatePicker>
      
      { error ? (
        <p className="mb-0 text-danger">{errorText}</p>
      ) : null }
    </>
  )
};

DatePicker.propTypes = {
  
};


DatePicker.defaultProps = {
  
};

